import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {LoaderService} from '../../services/loader.service';

@Component({
  selector: 'si-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoaderComponent implements OnInit, OnDestroy {
  show = false;

  constructor(private loaderService: LoaderService) {}

  ngOnInit() {
    this.loaderService.register(this);
  }

  ngOnDestroy(): void {
    this.loaderService.unregister();
  }

}
